import { Card, Typography, Chip, Stack } from "@mui/material";
import { Box } from "@mui/system";
import {
  colors,
  spacing,
  typography,
} from "../../../../../../../../../../assets/styles/tokens";
import {
  PERCENT_STYLES,
  cleanNumber,
  formatDate,
  formatInt,
} from "../../../../../../../DashboardDesktop/Anomalies/AnomaliesTabs/Utils/anomaliesColumns";

// ─────────────────────────────────────────────────────────────────────────────

// Gap indicator (matches the existing Business Development convention,
// e.g. IncomeGapsTable's isHighlighted): red when the gap magnitude exceeds
// the threshold, default styling otherwise.
const GAP_HIGHLIGHT_THRESHOLD = 2;

interface NoPlayerCardProps {
  brand_name: string;
  brand_id: string;
  brand_action_date: string;
  gap: number | string;
  playersFtd: number | string;
  dailyFtd: number | string;
}

export function NoPlayerCard({
  brand_name,
  brand_id,
  brand_action_date,
  gap,
  playersFtd,
  dailyFtd,
}: NoPlayerCardProps) {
  const gapNum = cleanNumber(gap);
  const isGapHighlighted = Math.abs(gapNum) > GAP_HIGHLIGHT_THRESHOLD;

  return (
    <>
      <Card
        sx={{
          p: 1,
          borderRadius: spacing.Radius.lg.$value,
          boxShadow: "0px 1px 2px #0A0D120F , 0px 1px 3px #0A0D121A",
          border: "1px solid" + colors.GrayLightMode[200].$value,
          mb: spacing.Spacing.none.$value,
          mt: spacing.Spacing.xl.$value + "!important",
        }}
      >
        {/* Top Row */}
        <Stack
          direction="row"
          justifyContent="space-between"
          alignItems="center"
        >
          <Typography
            variant="body1"
            sx={{
              color: colors.GrayLightMode[700].$value,
              fontSize: typography.Size.Text.xs.$value,
              fontWeight: typography.Font_weight.Medium.$value,
              mb: spacing.Spacing.md.$value,
            }}
          >
            {brand_name} ({brand_id})
          </Typography>
        </Stack>

        <Stack
          sx={{
            justifyContent: "space-between",
            flexDirection: "row",
            alignItems: "center",
          }}
        >
          <Typography
            variant="body1"
            sx={{
              fontSize: typography.Size.Text.sm.$value,
              color: colors.GrayLightMode[900].$value,
            }}
          >
            Gap in Player's Reporting
          </Typography>
          <Chip
            label={formatInt(gap)}
            size="medium"
            sx={{
              borderRadius: spacing.Radius.xs.$value,
              fontSize: typography.Size.Text.md.$value,
              bgcolor: isGapHighlighted
                ? PERCENT_STYLES.red.bg
                : colors.GrayLightMode[100].$value,
              color: isGapHighlighted
                ? PERCENT_STYLES.red.color
                : colors.GrayLightMode[900].$value,
              fontWeight: typography.Font_weight.Semibold.$value,
            }}
          />
        </Stack>

        <Stack>
          <Typography
            variant="body1"
            sx={{
              fontSize: typography.Size.Text.sm.$value,
              color: colors.GrayLightMode[900].$value,
              mb: spacing.Spacing.sm.$value,
            }}
          >
            Brand Action Date:
            <Box
              component="span"
              sx={{
                fontSize: typography.Size.Text.sm.$value,
                fontWeight: typography.Font_weight.Medium.$value,
                ml: spacing.Spacing.xs.$value,
              }}
            >
              {formatDate(brand_action_date)}
            </Box>
          </Typography>
        </Stack>

        <Stack
          direction="row"
          justifyContent="space-between"
          mt={spacing.Spacing.xs.$value}
          mb={spacing.Spacing.md.$value}
        >
          <Box
            sx={{
              width: "50%",
              borderRight: "1px solid" + colors.GrayLightMode[200].$value,
              pr: spacing.Spacing.md.$value,
            }}
          >
            <Typography
              mb={spacing.Spacing.xs.$value}
              sx={{
                color: colors.GrayLightMode[500].$value,
                fontSize: typography.Size.Text.xs.$value,
              }}
            >
              FTD's in Player Report
            </Typography>
            <Box>
              <Typography
                sx={{
                  color: colors.GrayLightMode[900].$value,
                  fontSize: typography.Size.Text.md.$value,
                  fontWeight: typography.Font_weight.Semibold.$value,
                  pr: spacing.Spacing.xs.$value,
                }}
              >
                {formatInt(playersFtd)}
              </Typography>
            </Box>
          </Box>
          <Box
            sx={{
              width: "50%",
              pl: spacing.Spacing.md.$value,
            }}
          >
            <Typography
              mb={spacing.Spacing.xs.$value}
              sx={{
                color: colors.GrayLightMode[500].$value,
                fontSize: typography.Size.Text.xs.$value,
              }}
            >
              FTD's in Daily Report
            </Typography>
            <Box>
              <Typography
                sx={{
                  color: colors.GrayLightMode[900].$value,
                  fontSize: typography.Size.Text.md.$value,
                  fontWeight: typography.Font_weight.Semibold.$value,
                  pr: spacing.Spacing.xs.$value,
                }}
              >
                {formatInt(dailyFtd)}
              </Typography>
            </Box>
          </Box>
        </Stack>
      </Card>
    </>
  );
}
export default NoPlayerCard;
